import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteScheduling, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../../../../components/reduxFields';
import { base64Encode, GetReportUrl, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import { getPatient, getMasterData } from '../../actions/index';
import history from '../../../../history';
import {getPatientListWithPermission} from '../../actions/index';
import {HasUrlAccess} from '../../actions/index';

class AccountLedgerReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      // iframeURL: `${REPORT_URL}?%2fHC.SqlReports%2fPatientAppointmentReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.props.orgID + '&LocationID=' + this.props.locationID,
      iframeURL: '',
      isLoading: false,
      random: 0,
      isSearchBySubmittedDates : false
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
    this.checkReportSearch = this.checkReportSearch.bind(this);
  }

  componentWillMount() {   
    this.props.HasUrlAccess('/reports/account-ledger');    
    let masterData = {
      'masterdata': 'CLAIMPAYMENTSTATUS,CLAIMOFFICEALLYSTATUS,MASTERINSURANCECOMPANY',
    };    
     this.props.getMasterData(masterData);    

     let searchObj = {
      locationIds: '0',
      isActiveCheckRequired: 'YES',
      viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission,
    };
    this.props.getPatientListWithPermission(searchObj);
  }

    onDateChange = (input, value) => {
      input.onChange(moment(value).format());
      this.setState({
        [input.name]: value,
      });
    }

    appointmentFilterByDate = (formData) => {
      this.resetIframe();

      let FromDateFormat;
      let ToDateFormat;
      let DateFormat;
      let dateFormat;

      if (Object.keys(formData).length) {
        FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
        ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
      } else {
        DateFormat = new Date().setDate(new Date().getDate() - 7);
        FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
        dateFormat = new Date();
        ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
      }
      let REPORT_URL  = GetReportUrl(this.props.agencyName);  
      let reportName = base64Encode('FC_PAL_RPT');
      this.setState({
        isLoading: true,
        iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "FromAppointmentDate","Value": "`+ FromDateFormat + `"},{"Name": "ToAppointmentDate","Value": "`+ ToDateFormat + `"},{"Name": "LocationID","Value": "`+ (formData.location || 0) + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"},{"Name": "PatientIds","Value": "`+ (formData.patientIds && formData.patientIds.length > 0 ? formData.patientIds : 0) + `"},{"Name": "PayerIds","Value": "`+ (formData.payerIds && formData.payerIds.length > 0 ? formData.payerIds : 0) + `"},{"Name": "ClaimPaymentStatusIds","Value": "`+ (formData.claimPaymentStatusIds && formData.claimPaymentStatusIds.length > 0 ? formData.claimPaymentStatusIds : 0) + `"},{"Name": "ClaimOfficeallyStatusIds","Value": "`+ (formData.claimOfficeallyStatusIds && formData.claimOfficeallyStatusIds.length > 0 ? formData.claimOfficeallyStatusIds : 0) + `"},{"Name": "IsSearchBySubmittedDates","Value": "` + this.state.isSearchBySubmittedDates + `"},{"Name": "ViewTeamClientsOnlyPermissionForReports","Value": "` + this.props.viewTeamClientsOnlyPermission + `"},{"Name": "LoginUserId","Value": "` + this.props.loginUserID + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
      });
    }

    onLoadReport = (e) => {
      this.setState({ isLoading: false});
    }

  handleChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleNewChange = (input, selectedRecord) => {
    //if (input.name === 'staffIds') {
      input.onChange(selectedRecord);
    //}
    // else{
    //   input.onChange(selectedRecord.value);
    //   this.props.GetStaffByLocation(selectedRecord.value, 'YES')
    // }
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/financial-reports');
  }
  checkReportSearch = (e, name) => {
    if (name === 'isSearchBySubmittedDates') {
      if(e.target.checked) 
      {
        this.setState({isSearchBySubmittedDates : true});       
      }
      else
      {
        this.setState({isSearchBySubmittedDates : false});
      }
    }    
  }
  render() {
    const { handleSubmit } = this.props;    
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Financial {' > '} Account Ledger Report</h2>
        :
          <h2 className="page_title">Account Ledger Report</h2>
        }   
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-4 mt-30">
                  <Field name="location"
                    label="Location"
                    handleNewRequest={this.handleChange}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-4 mt-35">
                    <Field
                      name="payerIds"
                      label="Insurance Company"
                      handleNewRequest={this.handleNewChange}
                      options={this.props.masterInsuranceCompanies}
                      component={renderAutoCompleteScheduling}
                      fullWidth={true}
                    />
                </div>
                <div className="col-sm-4 mt-35">
                    <Field
                      name="patientIds"
                      label="Client"
                      handleNewRequest={this.handleNewChange}
                      options={this.props.patientlist}
                      component={renderAutoCompleteScheduling}
                      fullWidth={true}
                    />
                </div>
              </div>
              <div className="row">
              <div className="col-sm-4 mt-35">
                    <Field
                      name="claimPaymentStatusIds"
                      label="Claim Payment Status"
                      handleNewRequest={this.handleNewChange}
                      options={this.props.masterClaimPaymentStatus}
                      component={renderAutoCompleteScheduling}
                      fullWidth={true}
                    />
                </div>                
                <div className="col-sm-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />

                </div>
                <div className="col-sm-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 mt-35">
                    <Field
                      name="claimOfficeallyStatusIds"
                      label="Claim Clearinghouse Status"
                      handleNewRequest={this.handleNewChange}
                      options={this.props.masterClaimOfficeallyStatus}
                      component={renderAutoCompleteScheduling}
                      fullWidth={true}
                    />
                </div>
                <div className="col-sm-3 mt-30">
                    <Field
                      className="mt25"
                      name="isSearchBySubmittedDates"
                      label="Search by Claim Submitted Dates"
                      onChange={(e) => this.checkReportSearch(e, 'isSearchBySubmittedDates')}
                      component={renderCheckBox}
                    />
                </div>
                <div className="col-sm-2 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e)=> this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

AccountLedgerReport = reduxForm({
  form: 'AccountLedgerReportForm',
})(AccountLedgerReport);

function mapStateToProps(state) {
  let locationArr = [], patients = [];
  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }

  if (state.report.patientList && state.report.patientList.data) {
    patients = state.report.patientList.data.patients;
  }

  // Start For Role Permission

 let userScreenPermission = [];
 if (state.login.userPermission) {
   let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
   userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
 }

 let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0].permission : false;


 // End For Role Permission
    
  return {
    orgID: state.login.loginUserInfo.organizationID,
    userLocationList: locationArr,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    patientlist: patients,
    masterInsuranceCompanies:  (state.report.master_data && state.report.master_data.insuranceCompanies) || [],
    masterClaimPaymentStatus: (state.report.master_data && state.report.master_data.claimPaymentStatus) || [],
    masterClaimOfficeallyStatus: (state.report.master_data && state.report.master_data.claimOfficeallyStatus) || [],
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    loginUserID: (state.login.loginUserInfo && state.login.loginUserInfo.userID) || null,
  };
}
export default connect(mapStateToProps, { getPatientListWithPermission, HasUrlAccess, getMasterData})(AccountLedgerReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/FinancialReports/accountLedgerReport.js